var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3C1.25 2.58579 1.58579 2.25 2 2.25H22C22.4142 2.25 22.75 2.58579 22.75 3C22.75 3.41421 22.4142 3.75 22 3.75H19V12.4608C21.1423 12.8804 22.75 14.7878 22.75 17.0625C22.75 19.6425 20.6819 21.75 18.1111 21.75C15.5404 21.75 13.4722 19.6425 13.4722 17.0625C13.4722 14.6905 15.2204 12.7179 17.5 12.4152V3.75H6.5V12.4152C8.77964 12.7179 10.5278 14.6905 10.5278 17.0625C10.5278 19.6425 8.45963 21.75 5.88889 21.75C3.31815 21.75 1.25 19.6425 1.25 17.0625C1.25 14.7878 2.85765 12.8804 5 12.4608V3.75H2C1.58579 3.75 1.25 3.41421 1.25 3ZM5.88889 13.875C4.16409 13.875 2.75 15.2933 2.75 17.0625C2.75 18.8317 4.16409 20.25 5.88889 20.25C7.61369 20.25 9.02778 18.8317 9.02778 17.0625C9.02778 15.2933 7.61369 13.875 5.88889 13.875ZM18.1111 13.875C16.3863 13.875 14.9722 15.2933 14.9722 17.0625C14.9722 18.8317 16.3863 20.25 18.1111 20.25C19.8359 20.25 21.25 18.8317 21.25 17.0625C21.25 15.2933 19.8359 13.875 18.1111 13.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.de636d1bb165cefc1acb7ee2d2ce80d2.svg";
export { ForwardRef as ReactComponent };